import { type FunctionComponent, useCallback } from 'react';
import {
  MessageInput,
  type MessageUIComponentProps,
  Modal,
  useMessageComposer,
  useMessageContext,
} from 'stream-chat-react';
import { EditMessageForm } from './EditMessageForm/EditMessageForm';

export type EditMessageModalProps = Pick<
  MessageUIComponentProps,
  'additionalMessageInputProps'
>;

export const EditMessageModal: FunctionComponent<EditMessageModalProps> = ({
  additionalMessageInputProps,
}) => {
  const { clearEditingState } = useMessageContext();
  const messageComposer = useMessageComposer();
  const onEditModalClose = useCallback(() => {
    clearEditingState();
    messageComposer.restore();
  }, [clearEditingState, messageComposer]);

  return (
    <Modal
      className="str-chat__edit-message-modal"
      onClose={onEditModalClose}
      open
    >
      <MessageInput
        clearEditingState={clearEditingState}
        focus
        hideSendButton
        Input={EditMessageForm}
        {...additionalMessageInputProps}
      />
    </Modal>
  );
};
